import { Grid } from '@mui/material'
import Drawer from '@mui/material/Drawer'
import { searchContentInOrganization } from 'api/organization'
import DrawerContainer from 'components/drawer/common/DrawerContainer'
import DrawerHeader from 'components/drawer/common/DrawerHeader'
import FailPlaceholder from 'components/placeholders/FailPlaceholder'
import { defaultDrawerSX } from 'const'
import { useState } from 'react'
import { useQuery } from 'react-query'
import { TableResponse, TipSearchResult } from 'types'
import { TipDrawerView } from '../../../Tips/components/TipDrawerView/TipDrawerView'
import { OrganizationSearchResultItem } from './OrganizationSearchResultItem'

export function OrganizationSearchDrawer({
  isOpen,
  searchQuery,
  handleClose,
}: {
  isOpen: boolean
  searchQuery: string
  handleClose: () => void
}) {
  const [selectedTipId, setSelectedTipId] = useState<number | null>(null)

  const query = useQuery(
    ['searchContentInOrganization', searchQuery],
    () => searchContentInOrganization(searchQuery),
    {
      enabled: isOpen && searchQuery.length > 0,
      select: (req: TableResponse<TipSearchResult>) => {
        return req.data
      },
      cacheTime: 0,
      staleTime: 0,
    },
  )

  const handleCloseWithBlur = () => {
    const active = document.activeElement as HTMLElement | null
    active?.blur?.()
    handleClose()
  }

  const handleTipClick = (tipId: number) => {
    setSelectedTipId(tipId)
  }

  const handleCloseTipDrawer = () => {
    setSelectedTipId(null)
  }

  return (
    <>
      <Drawer anchor="right" open={isOpen} onClose={handleCloseWithBlur} sx={defaultDrawerSX}>
        {isOpen && (
          <DrawerContainer
            isOpen={isOpen}
            hasData={!!query.data}
            loading={query.isLoading}
            handleClose={handleClose}
          >
            <DrawerHeader handleClose={handleClose}>Search results:</DrawerHeader>

            {query.data?.rows?.length === 0 && (
              <FailPlaceholder error="No content was found by entered parameters" mb={4} />
            )}

            <Grid container direction="row" spacing={2}>
              {query.data?.rows?.map((it: TipSearchResult) => {
                return (
                  <Grid key={String(it.itemId)} item xs={12} sm={6} md={4}>
                    <OrganizationSearchResultItem
                      name={it.name}
                      id={it.itemId}
                      onTipClick={handleTipClick}
                    />
                  </Grid>
                )
              })}
            </Grid>
          </DrawerContainer>
        )}
      </Drawer>

      {selectedTipId && (
        <TipDrawerView id={selectedTipId} isOpen handleClose={handleCloseTipDrawer} />
      )}
    </>
  )
}
